import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../core/shared.module';
import { EmployeeShowComponent } from './employee-show/employee-show.component';
import { EmployeeService } from "../core/services/employee.service";
import { EmploymentShowComponent } from "../verification-show/employment-show/employment-show.component";
import { EducationShowComponent } from "../verification-show/education-show/education-show.component";
import { AddressShowComponent } from "../verification-show/address-show/address-show.component";
import { ReferenceShowComponent } from "../verification-show/reference-show/reference-show.component";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,

    ],
    declarations: [
        EmployeeShowComponent,
        EmploymentShowComponent,
        EducationShowComponent,
        AddressShowComponent,
        ReferenceShowComponent
    ],
    providers: [EmployeeService],
})
export class EmployeeModule {
}


// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/employee/employee.module.ts